import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { deepArticles } from "@/mocks/articles";

export default function DeepSection() {
  const [featured, ...rest] = deepArticles;
  const sideList = rest.slice(0, 3);
  const bottomList = rest.slice(3);

  return (
    <section id="deep" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <SectionHeading
          eyebrow="DEEP DIVE"
          title="深度追踪：把一次出圈拆开来看"
          description="热度之外，我们更关心话题是怎么被传开的。这些复盘文章会告诉你扩散背后的节点、误区与加速引擎。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <article className="group lg:col-span-7">
            <Link to={`/article/${featured.id}`} className="block h-full overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <div className="relative h-56 w-full overflow-hidden md:h-72">
                <img
                  src={featured.cover}
                  alt={`深度追踪配图：${featured.title}`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  {featured.category}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-2xl">
                  {featured.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  {featured.excerpt}
                </p>
                <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                  <span>{featured.author}</span>
                  <span>{featured.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" />
                    {featured.readTime}
                  </span>
                </div>
              </div>
            </Link>
          </article>

          <div className="flex flex-col gap-4 lg:col-span-5">
            {sideList.map((article) => (
              <article key={article.id} className="group flex-1">
                <Link
                  to={`/article/${article.id}`}
                  className="flex h-full gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300"
                >
                  <div className="h-24 w-24 shrink-0 overflow-hidden rounded-md md:h-28 md:w-28">
                    <img
                      src={article.cover}
                      alt={`深度追踪配图：${article.title}`}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex flex-1 flex-col justify-between">
                    <div>
                      <span className="text-xs font-medium text-primary-600">{article.category}</span>
                      <h3 className="mt-1.5 font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                        {article.title}
                      </h3>
                    </div>
                    <div className="flex items-center gap-3 text-xs text-foreground-500">
                      <span>{article.date}</span>
                      <span>{article.readTime}</span>
                    </div>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </div>

        {bottomList.length > 0 && (
          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
            {bottomList.map((article) => (
              <article key={article.id} className="group">
                <Link
                  to={`/article/${article.id}`}
                  className="flex items-center justify-between gap-4 rounded-lg border border-background-200 bg-background-100 px-5 py-4 transition-colors hover:border-primary-300"
                >
                  <div>
                    <span className="text-xs font-medium text-primary-600">{article.category}</span>
                    <h3 className="mt-1.5 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                      {article.title}
                    </h3>
                  </div>
                  <i className="ri-arrow-right-up-line shrink-0 text-xl text-foreground-400 transition-colors group-hover:text-primary-600" />
                </Link>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}